webpackJsonp([49],{

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TeleCareExistingCustomerFormPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vivalid = __webpack_require__(236);

var _vivalid2 = _interopRequireDefault(_vivalid);

var _utils = __webpack_require__(77);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'TeleCareExistingCustomerFormPage';
var CLS = 'teleCareExistingCustomerFormPage';
var PG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

var TeleCareExistingCustomerFormPage = exports.TeleCareExistingCustomerFormPage = function () {
	// TODO: confirm form submission details
	// How will show/hide of customer details section affect the form when submitting data
	function TeleCareExistingCustomerFormPage($el) {
		_classCallCheck(this, TeleCareExistingCustomerFormPage);

		// $el is the page node return by the loadTeleCareExistingCustomerFormPage function
		this.$el = $el;
	}

	_createClass(TeleCareExistingCustomerFormPage, [{
		key: 'init',
		value: function init() {
			this.setTeleCareExistingCustomerFormPage();
			this.setFormValidation();
		}
	}, {
		key: 'setTeleCareExistingCustomerFormPage',
		value: function setTeleCareExistingCustomerFormPage() {
			// Add Some logic here
			if ($('#radioOther').prop('checked')) {
				$(PG + 'customerDetailsContainer').show();
			} else {
				$(PG + 'customerDetailsContainer').hide();
			}

			$('.alarmEnquiry').on('click', function () {
				// reset validation
				$('.reset-form-validation').trigger('click');

				var val = $(this).val();
				if (val === 'mine') {
					$(PG + 'customerDetailsContainer').hide();
				} else {
					$(PG + 'customerDetailsContainer').show();
				}
			});
		}

		// Add more functions like on above here

	}, {
		key: 'setFormValidation',
		value: function setFormValidation() {
			var $pg = $(this.$el);
			utils.formValidationRules();

			var addCallback = _vivalid2.default.htmlInterface.addCallback;
			var initAllValidations = _vivalid2.default.htmlInterface.initAll;

			addCallback('onValidationSuccess', function () {
				var $form = $pg.find('form');
				$('.loading-spinner').addClass('is-active');
				// eslint-disable-next-line no-undef
				grecaptcha.ready(function () {
					// eslint-disable-next-line no-undef
					grecaptcha.execute('6Lfp5PooAAAAAD_AMAUIzJ4TWqpOGmSCsg6ZpsZu', { action: 'BuyStJohnTelecareExistingCustomerEnquiry' }).then(function (token) {
						// Add your logic to submit to your backend server here.

						var recaptcha = token;
						var recaptchaErr = $form.find('#recaptcha-error');
						if (!recaptcha || recaptcha === '') {
							// error div for recpatcha
							recaptchaErr.removeClass('d-none');
							$pg.find('button[type="submit"]').prop('disabled', false);
						} else {
							$form.find('#CaptchaVerifyKey').val(recaptcha);
							recaptchaErr.addClass('d-none');
							$form[0].submit();
						}
					});
				});
			});
			addCallback('onValidationFailure', function (invalid, pending, valid) {
				var popUpErrorMessage = $('#pop-up-err-msg').val();
				alert(popUpErrorMessage);
			});

			initAllValidations();
		}
	}]);

	return TeleCareExistingCustomerFormPage;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ })

});


// WEBPACK FOOTER //
// pg-tele-care-existing-customer-form-page-chunk.js